import React from 'react'
import AnimateImageSeven from './AnimateImageSeven'
import AnimateTitleSeven from './AnimatedTitleSeven'

const Packaging = () => {
    return (
        <section className='section-packaging section-padding'>
            <div className='container'>
                <div className='row'>
                <div className='col-md-5'>
                   <div className='section-content-wrapper'>
                     <div className='section-paragraph'>
                        <p>The final step is presentation. Once approved, each garment is gently cleaned, pressed, and packaged using eco-conscious materials. We believe packaging is the first touchpoint of experience — an introduction to the story that lies within each creation.</p>
                     </div>
                   </div>
                </div>
                <div className='col-md-7'>
                    <div className='section-img-heading'>
                     <div className='section-title'>
                        <AnimateTitleSeven/>
                     </div>
                    <div className='animated-image-wrapper'>
                        <AnimateImageSeven/>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default Packaging